<!-- Start: Rejwan: 19-06-2025 Reporting -->
<template>
    <div class="">
        <div class="clearfix company-form-container-warapper"> <!-- Mustafijur: 01-06-2026: Removed  company-form-container -->
            <div class="custom-loader-wrapper" v-if="loader">
                <div class="text-center">
                    <span class="d-block max-450">We are processing your download and this may take some time. Do not close this window until the download begins.</span>
                    <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                    <p class="mt-5">Plesae click <a target="_blank" :href="$api_url+'/company/dashboard'">here</a> or below if you want to continue surfing the system.</p>
                    <b-button  class="mb-1"  target="_blank"  :href="$api_url+'/company/dashboard'">Dashboard</b-button>

                </div>
            </div>

            <!-- Mustafijur: 01-06-2026: Start -->
            <!-- <div class="company-form-container-title-wrapper">
                <div class="col-sm-12 px-3 company-form-box-title">
                    <div class="trustee-nav-first">
                        <div class="trustee-nav-head">Monthly Loan Collection Report</div>
                        <div class="trustee-nav-subhead">Select parameters below to generate and download report.</div>
                    </div>
                </div>
            </div>

            <div class="report-button-contents">
                <div class="row">
                    <div class="col-3">
                        <b-form-select class="" v-model="selected_year">
                            <b-form-select-option disabled value="">Please Select Year</b-form-select-option>
                            <b-form-select-option v-for="(year,index)  in years" :key="index"  :value="year">{{year}}</b-form-select-option>
                        </b-form-select>
                    </div>
                    <div class="col-3">
                        <b-form-select class="" v-model="selected_month">
                            <b-form-select-option disabled valu="">Please Select Month</b-form-select-option>
                            <b-form-select-option v-for="(label, value)  in months" :key="value"  :value="parseInt(value)">{{label}}</b-form-select-option>
                        </b-form-select>
                    </div>
                </div>

                <div class="button_wrapper">
                    <button v-on:click="getReport()" class="btn btn-primary position-static">Download</button>
                </div>
            </div> -->

            <div class="row mt-4 no-margin">
                <div class="ibox col-md-12">
                    <div class="ibox-title dashboard_title px-0">
                        <h4 class="font-regular with-blue-text">Current Selected: <span>Monthly Loan Collection Report</span></h4>
                        <h4>Select parameters below to generate and download report.</h4>
                    </div>
                    <div class="ibox-content px-0 trz_ppl_wrapper_2">

                        <div class="row">
                            <div class="col-3">
                                <b-form-select class="" v-model="selected_year">
                                    <b-form-select-option disabled :value="null">Please Select Year</b-form-select-option>
                                    <b-form-select-option v-for="(year,index)  in years" :key="index"  :value="year">{{year}}</b-form-select-option>
                                </b-form-select>
                            </div>
                            <div class="col-3">
                                <b-form-select class="" v-model="selected_month">
                                    <b-form-select-option disabled :value="null">Please Select Month</b-form-select-option>
                                    <b-form-select-option v-for="(label, value)  in months" :key="value"  :value="parseInt(value)">{{label}}</b-form-select-option>
                                </b-form-select>
                            </div>
                        </div>

                        <div class="d-inline-block mt-3">
                            <button v-on:click="getReport()" class="btn btn-primary position-static">Download</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Mustafijur: 01-06-2026: Ends -->

        </div>
    </div>
</template>

<script>


    export default{

        mounted() {
        },
        props: [],
        components: {

        },
        data(){

            return {

                empty_result : 'Please hold tight! We are preparing the report data for you!',
                loader: false,
                showoverlay : true,
                years: [],
                selected_year: null,
                months: {
                    1: "January",
                    2: "February",
                    3: "March",
                    4: "April",
                    5: "May",
                    6: "June",
                    7: "July",
                    8: "August",
                    9: "September",
                    10: "October",
                    11: "November",
                    12: "December"
                },
                selected_month: null,
            }
        },
        methods:{
            getReport: function()
            {
                if(!this.checkNet()) return false;
                this.loader = true;

                if(this.selected_year == null || this.selected_month == null) {
                    this.$bvToast.toast('Year and Month is Required', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                    this.loader = false;
                    return false;
                }

                let url = ''

                url = this.$api_url + '/pf/report/monthly-loan-collection';

                let formData = new FormData();
                formData.append('selected_month', this.selected_month);
                formData.append('selected_year', this.selected_year);

                let currentObj = this;
                this.downloadBlobResponse(
                    axios.post(url, formData, { responseType: 'blob' }),
                    'loader' // your loader key in this component
                );
                return false;
            },
            download_file(fileURL)
            {
                if(!this.checkNet()) return false;

                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },
            replaceTableHeads(val){
                val = val.replace(/_/g, ' ');

                val = val.toLowerCase().split(' ');
                for(var i = 0; i < val.length; i++){
                    val[i] = val[i].charAt(0).toUpperCase() + val[i].substring(1);
                }
                return val.join(' ');
            },

        },
        created: function(){
            const startYear = 2010;
            const currentYear = new Date().getFullYear();
            for (let y = startYear; y <= currentYear; y++) {
                this.years.push(y);
            }
        },
        computed:
        {

        }
    }
</script>

<!-- End: Rejwan: 19-06-2025 Reporting -->
